import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { faUndo, faTrash } from '@fortawesome/free-solid-svg-icons';

import DashItemMenu from 'components/DashItemMenu';
import ModifiedCell from 'components/table/ModifiedCell';
import DateCell from 'components/table/DateCell';

import {
  getFSObjectName,
  getFSObjectDesc,
  getFSObjectType,
} from './fsObjectUtils';

import FSObjectIcon from './FSObjectIcon';

const IconWrapper = styled.div`
  border-radius: 20px;
  width: 24px;
  text-align: center;
  cursor: pointer;
`;

const Name = styled.div`
  color: #333;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 4px;
  cursor: pointer;
`;

const Description = styled.div`
  color: #767676;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
`;
const StyledTD = styled.td`
  vertical-align: middle !important;
  padding: 1rem 0 !important;
`;

const SettingsTD = styled(StyledTD)`
  text-align: right;
`;

const FSObjectArchiveListItem = ({
  item,
  onDeleteClick,
  onRestoreClick,
  onClick,
}) => {
  const kind = getFSObjectType(item);

  const items = [
      {
        onClick: onRestoreClick.bind(null, item._id),
        icon: faUndo,
        title: ` Restore ${kind}`,
      },
      {
        onClick: onDeleteClick.bind(null, item),
        icon: faTrash,
        title: ` Delete forever`,
      },
    ],
    settingsNode = <DashItemMenu items={items} />;
  return (
    <tr>
      <StyledTD>
        <IconWrapper>
          <FSObjectIcon item={item} />
        </IconWrapper>
      </StyledTD>
      <StyledTD>
        <NameCell
          name={getFSObjectName(item)}
          description={getFSObjectDesc(item)}
          onClick={onClick}
        />
      </StyledTD>
      <StyledTD className="d-none d-lg-table-cell">
        <DateCell date={item.startOn} />
      </StyledTD>
      <StyledTD className="d-none d-lg-table-cell">
        <ModifiedCell item={item} />
      </StyledTD>
      <SettingsTD>{settingsNode}</SettingsTD>
    </tr>
  );
};

FSObjectArchiveListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onRestoreClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export const NameCell = ({ name, description, onClick }) => {
  return (
    <>
      <Name onClick={onClick}>{name}</Name>
      <Description>{description}</Description>
    </>
  );
};

export default FSObjectArchiveListItem;
